import { schema } from "normalizr";
import { Statement } from "./statement";

export const Statements = new schema.Array(Statement);
